var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphPhysicalStress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-95 27.772 25.273)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDBBB",
    cx: 20.994,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFAB61",
    transform: "rotate(20 11.665 29.53)",
    x: 4.165,
    y: 16.03,
    width: 15,
    height: 27,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "m40.65 48.894-.912-5.171a6 6 0 0 1 2.407-5.914l18.04-12.968a2.5 2.5 0 0 1 3.922 1.596l.912 5.171a6 6 0 0 1-2.407 5.914L44.572 50.49a2.5 2.5 0 0 1-3.922-1.596z",
    fill: "#FFAB61"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFDBBB",
    transform: "rotate(-13 25.053 27.85)",
    x: 20.053,
    y: 13.851,
    width: 10,
    height: 28,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.234 0H42.8a2.917 2.917 0 0 1 2.362 4.629l-8.783 12.114a2.917 2.917 0 0 1-4.723 0L22.873 4.629A2.917 2.917 0 0 1 25.234 0z",
    fill: "#FF375E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphPhysicalStress);
export default __webpack_public_path__ + "static/media/icons_graph_physical_stress.0176eb67e3a69e6d8034432b3a0a9d7f.svg";
export { ForwardRef as ReactComponent };